import BureausCreate from './BureausCreate';

export const Bureaus: object = {
  create: BureausCreate,
};

export default Bureaus;
